/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
const facelivenessS3Bucket = process.env.REACT_APP_FACELIVENESS_S3_BUCKET || 'staticfintech01';
const identityPoolId = process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID;
const environment = process.env.REACT_APP_ENVIRONMENT;

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": identityPoolId,
    "aws_user_files_s3_bucket": `${facelivenessS3Bucket}-${environment}`,
    "aws_user_files_s3_bucket_region": "us-east-1"
};

export default awsmobile;
